export default __webpack_public_path__ + "static/media/training.20827dc9.svg";